import React from "react";
import "./homehoursec.css";
// import { SiCssdesignawards } from "react-icons/si";
import "./../style/common.css";
import { Link } from "react-router-dom";


function HomeHoursec() {
  return (
    <div>
      <section className="about-section-home">
        <div className="about-image">
          <img src="/Images/About-us.png" alt="Pouring Coffee" loading="lazy" />
        </div>

        <div className="about-content-home">
          {/* <p className="subheading"> <SiCssdesignawards/> LOREM IPSUM SUB HEADING</p> */}
          <h2>
            WE ARE NOT YOUR AVERAGE
            <br />
            COFFEE SHOP
          </h2>
          <p className="description-about-home">
            It is not just a place to drink coffee; it's where you get all
            Indian flavors at one place. It is a place where discussions begin,
            ideas emerge, and flavour takes front stage.
          </p>
          <p className="description-about-home">
            Mandurah Cafe is a space for everyone - students, creatives,
            entrepreneurs, coffee lovers, and foodies. Step inside and discover
            a space where south Indian dosas meet with North Indian Naans, where
            Indian snacks and Aussie breakfast share the same table. This is not
            your average coffee shop. It is where you get bold flavors, warm
            vibes and honest food at one place.
          </p>
    <Link to="/about-mandurah-cafe" className="explore-button">
  Read More
</Link>
        </div>
        <div className="opening-hours-wrapper">
          <div className="opening-hours-card">
            <h3>OPENING HOURS</h3>
            <ul>
              <li>
                <span>MONDAY</span>
                <span>:</span>
                <span>6:00 AM – 5:00 PM</span>
              </li>
              <li>
                <span>TUESDAY</span>
                <span>:</span>
                <span>6:00 AM – 5:00 PM</span>
              </li>
              <li>
                <span>WEDNESDAY</span>
                <span>:</span>
                <span>6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span>THURSDAY</span>
                <span>:</span>
                <span>6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span>FRIDAY</span>
                <span>:</span>
                <span>6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span>SATURDAY</span>
                <span>:</span>
                <span>6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span>SUNDAY</span>
                <span>:</span>
                <span className="closed">8:00 AM – 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomeHoursec;
